import { ViewModel, View } from "binder"
import { ReplacementReasonEditorView } from "./replacementReasonEditor-view"
import { IReplacementReason } from "../IReplacementReason";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { ToolType, ToolTypeSelectorViewModel } from "../toolTypeSelector-viewModel";

export class ReplacementReasonEditorViewModel extends ViewModel implements IReplacementReason, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.toolTypeSelector = new ToolTypeSelectorViewModel(this);
        this.toolTypeSelector.onSelectionChanged = x => this.onToolTypeChanged(x);
    }
    GetDefaultView(): View<ViewModel> {
        return new ReplacementReasonEditorView();
    }
    public getTypeId(): string {
        return "VM-2C75E883-47E3-429D-8E3F-F1714F4B2772"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set reasonText(v: string) { this._reasonText = v; } public get reasonText(): string { return this._reasonText; } private _reasonText: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set toolTypeId(v: string) { this._toolTypeId = v; } public get toolTypeId(): string { return this._toolTypeId; } private _toolTypeId: string;
    public set toolTypeSelector(v: ToolTypeSelectorViewModel) { this._toolTypeSelector = v; } public get toolTypeSelector(): ToolTypeSelectorViewModel { return this._toolTypeSelector; } private _toolTypeSelector: ToolTypeSelectorViewModel;

    closePopup(result?: any) {

    }

    onToolTypeChanged(toolType: ToolType) {
        this.toolTypeId = toolType?.id;
    }

    setToolTypeId(id: string) {
        this.toolTypeSelector.selectById(id);
    }

    getToolTypeId(): string {
        return this.toolTypeSelector.selectedItem?.id;
    }

    async cloneTo(replacementReason: IReplacementReason) {
        replacementReason.id = this.id;
        replacementReason.reasonText = this.reasonText;
        replacementReason.code = this.code;
        replacementReason.setToolTypeId(this.getToolTypeId());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت علت تعویض');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت کد علت تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('علت تعویض با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت علت تعویض', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.reasonText)) {
            result.push('علت تعویض مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.code)) {
            result.push('کد علت تعویض مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.getToolTypeId())) {
            result.push('نوع ابزار مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(replacementReason: IReplacementReason): Promise<any>;
}

export class ReplacementReasonInserter implements IServerUpdater {
    async execute(replacementReason: IReplacementReason): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ReplacementReasonServices/CreateReplacementReason', {
                ReasonText: replacementReason.reasonText,
                Code: replacementReason.code,
                ToolTypeId: replacementReason.getToolTypeId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class ReplacementReasonUpdater implements IServerUpdater {
    async execute(replacementReason: IReplacementReason): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/ReplacementReasonServices/UpdateReplacementReason', {
                ReplacementReasonId: replacementReason.id,
                ReasonText: replacementReason.reasonText,
                Code: replacementReason.code,
                ToolTypeId: replacementReason.getToolTypeId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}
